<div class="h-100">
    <div class="row h-100">
        <div class="col">
            <hr>
            <h6 class="text-uppercase collapsible-text" (click)="patientAssessmentsCollapsible.toggleChange()">
                {{'ASSESSMENTS' | translate}}&nbsp;
                <app-collapsible #patientAssessmentsCollapsible [storageKey]="'member-assessment'"
                    [defaultCollapsed]="true" (collapsibleToggle)="memberAssessmentCollapsed=$event">
                </app-collapsible>
            </h6>
        </div>
    </div>
    <div class="row mt-3" *ngIf="!memberAssessmentCollapsed">
        <div class="col">
            <kendo-grid #grid [data]="gridView" [navigable]="true"
                [pageable]="total > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
                [pageSize]="state.take" [skip]="state.skip" [loading]="loading" [sort]="state.sort"
                [filter]="state.filter" [sortable]="true" [filterable]="enableAdvanced" [columnMenu]="enableAdvanced"
                [resizable]="true" [reorderable]="enableAdvanced" (dataStateChange)="dataStateChange($event)">
                <kendo-grid-messages noRecords="{{ 'NO-ASSESSMENTS' | translate }}">
                </kendo-grid-messages>
                <kendo-grid-column field="contactMethod.displayName" title="{{'METHOD' | translate}}" [width]="30">
                </kendo-grid-column>
                <kendo-grid-column field="name" title="{{ 'NAME' | translate }}" [width]="65">
                </kendo-grid-column>
                <kendo-grid-column field="type" title="{{ 'ASSESSMENT-TYPE' | translate }}" [width]="45">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span *ngIf="dataItem.type">{{dataItem.type.name}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="assessmentVersion" title="{{ 'VERSION' | translate }}" [width]="30">
                </kendo-grid-column>
                <kendo-grid-column field="contactEntity.displayName" title="{{'CONTACT-HISTORY-ENTITY' | translate}}"
                    [width]="55">
                </kendo-grid-column>
                <kendo-grid-column field="createdBy" [width]="50" title="{{ 'CREATED-BY' | translate }}">
                </kendo-grid-column>
                <kendo-grid-column field="createdOn" [width]="68" title="{{ 'CREATED-DATE' | translate }}" filter="date"
                    format="{0:g}">
                </kendo-grid-column>
                <kendo-grid-column field="lastModifiedBy" [width]="50" title="{{ 'LAST-MODIFIED-BY' | translate }}">
                </kendo-grid-column>
                <kendo-grid-column field="lastModifiedOn" [width]="68" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
                    filter="date" format="{0:g}">
                </kendo-grid-column>
                <kendo-grid-command-column [width]="50" title="{{ 'ACTIONS' | translate }}" class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <i class="fas fa-lg"
                            [ngClass]="{'fa-eye': dataItem.source === 'STATIC', 'fa-edit': dataItem.source === 'FORM', 
                                                         'extra-padding-2': !deleteAssessmentsEnabled && dataItem.source === 'FORM'}"
                            title="{{ (dataItem.source === 'STATIC' ? 'VIEW' : 'EDIT') | translate }}"
                            (click)="viewHandler(dataItem)" role="button"
                            attr.aria-label="{{ (dataItem.source === 'STATIC' ? 'VIEW' : 'EDIT') | translate }}"
                            tabindex="0" (keydown.enter)="viewHandler(dataItem)"
                            (keydown.space)="viewHandler(dataItem)">
                        </i>
                        &nbsp;
                        <span *ngIf="deleteAssessmentsEnabled">
                            <i class="fas fa-trash-alt fa-lg" [ngClass]="{'extra-padding': dataItem.source === 'FORM'}"
                                title="{{ 'DELETE' | translate }}" (click)="deleteHandler(dataItem)" role="button"
                                attr.aria-label="{{ 'DELETE' | translate }}" tabindex="0"
                                (keydown.enter)="deleteHandler(dataItem)" (keydown.space)="deleteHandler(dataItem)">
                            </i>
                            &nbsp;
                        </span>
                        <i *ngIf="dataItem.assessmentFulfillment && dataItem.assessmentFulfillment.url && dataItem.source === 'STATIC'"
                            class="fas fa-download fa-lg" title="{{ 'DOWNLOAD' | translate }}"
                            (click)="saveFileLocal(dataItem.assessmentFulfillment.url, dataItem.assessmentFulfillment.name)"
                            role="button" attr.aria-label="{{ 'DOWNLOAD' | translate }}" tabindex="0"
                            (keydown.enter)="saveFileLocal(dataItem.assessmentFulfillment.url, dataItem.assessmentFulfillment.name)"
                            (keydown.space)="saveFileLocal(dataItem.assessmentFulfillment.url, dataItem.assessmentFulfillment.name)">
                        </i>
                    </ng-template>
                </kendo-grid-command-column>
                <ng-template kendoGridDetailTemplate let-dataItem *ngIf="assessmentCommentsLoaded"
                    [kendoGridDetailTemplateShowIf]="showOnlyAssessmentComments">
                    <span class="montserrat" [innerHTML]="dataItem.assessmentComments | replaceLineBreaks"></span>
                </ng-template>
            </kendo-grid>
            <div class="mt-3">
                <button *ngIf="(addCaseAssessmentsEnabled && currentCaseId !== null) || (addClientAssessmentsEnabled &&
                currentCaseId === null)" kendoButton [primary]="true" type="button" class="float-right mb-2"
                    (click)="addHandler()">
                    {{'ADD-ASSESSMENT' | translate}}<i class="far fa-plus"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="k-overlay" *ngIf="documentDialogOpened"></div>
<kendo-window *ngIf="documentDialogOpened" [width]="1024" [height]="775" style="position:fixed" (close)="openDialog()"
    [state]="windowState" [top]="60" (resized)="onResized($event)" (stateChange)="onStateChange($event)">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text">{{'EDIT-ASSESSMENT' | translate}} - {{documentDescription}}
            </h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <button kendoWindowRestoreAction></button>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <!--loading-->
    <div *ngIf="loadingDocument" class="m-5">
        <div class="container">
            <div class="row justify-content-center">
                <span class="k-icon k-i-loading kendo-loading-icon"></span>
            </div>
        </div>
    </div>
    <!--Show document based on type-->
    <div *ngIf="!loadingDocument">
        <div *ngIf="isSupportedDocumentType">
            <div [ngSwitch]="documentMediaType">
                <div *ngSwitchCase="'image/png'">
                    <img alt="{{'DOCUMENT' | translate}}" class="document-content" [src]="documentImage"
                        *ngIf="documentImage">
                </div>
                <div *ngSwitchCase="'image/jpg'">
                    <img alt="{{'DOCUMENT' | translate}}" class="document-content" [src]="documentImage"
                        *ngIf="documentImage">
                </div>
                <div *ngSwitchCase="'image/bmp'">
                    <img alt="{{'DOCUMENT' | translate}}" class="document-content" [src]="documentImage"
                        *ngIf="documentImage">
                </div>
                <div *ngSwitchCase="'application/pdf'" class="document-content">
                    <kendo-pdfviewer style="width:100%;height:100vh;" [data]="documentContent" [tools]="pdfViewerTools">
                    </kendo-pdfviewer>
                </div>
                <div *ngSwitchCase="'application/json'" class="document-content">
                    <div #survey>
                        <div [ngSwitch]="isShowMemberExtension">
                            <form #formlyDiv *ngSwitchCase="false" [formGroup]="form" class="k-form ml-2 mr-2"
                                [ngStyle]="{'max-height': maxWindowHeight+'px'}">
                                <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
                            </form>
                            <kendo-splitter #splitter *ngSwitchCase="true" orientation="horizontal"
                                style="background-color:#f5f6fb; border: none;" (layoutChange)="updateSplitterBar()">
                                <kendo-splitter-pane class="mr-2" size="60%">
                                    <form #formlyDiv [formGroup]="form" class="k-form ml-2 mr-2"
                                        [ngStyle]="{'max-height': maxWindowHeight+'px'}">
                                        <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
                                    </form>
                                </kendo-splitter-pane>
                                <kendo-splitter-pane [collapsible]="true" [resizable]="true">
                                    <div class="w-100">
                                        <kendo-grid [data]="patViewExtensions.gridData" [navigable]="true"
                                            [selectable]="{ mode: 'single' }" [sortable]="true"
                                            [sort]="patViewExtensions.state.sort" [resizable]="true"
                                            [ngStyle]="{'max-height': currentMaxExtensionHeight+'px'}"
                                            (dataStateChange)="patExtensionsDataStateChange($event)"
                                            [kendoGridSelectBy]="'id'" class="ml-3">
                                            <kendo-grid-messages noRecords="{{ 'NO-EXTENSIONS' | translate }}">
                                            </kendo-grid-messages>
                                            <kendo-grid-column field="settingExtension.name" [width]="50"
                                                title="{{ 'NAME' | translate }}" [filterable]="false" [sortable]="true">
                                                <ng-template kendoGridCellTemplate let-dataItem>
                                                    <span title="{{dataItem.displayLabel}}"
                                                        *ngIf="dataItem.settingExtension">{{dataItem.settingExtension.name}}</span>
                                                </ng-template>
                                            </kendo-grid-column>
                                            <kendo-grid-column field="value" [width]="40"
                                                title="{{ 'VALUE' | translate }}">
                                                <ng-template kendoGridCellTemplate let-dataItem>
                                                    <span
                                                        *ngIf="dataItem.value">{{formatExtensionValue(dataItem)}}</span>
                                                </ng-template>
                                            </kendo-grid-column>
                                            <kendo-grid-column *ngIf="viewExtensionsShowAlternateValue"
                                                field="alternateValue" [width]="40"
                                                title="{{ 'ALTERNATE-VALUE' | translate }}">
                                            </kendo-grid-column>
                                            <kendo-grid-column *ngIf="viewExtensionsShowDisplayName" field="displayName"
                                                [width]="65" title="{{ 'DISPLAY-NAME' | translate }}">
                                            </kendo-grid-column>
                                        </kendo-grid>
                                    </div>
                                </kendo-splitter-pane>
                            </kendo-splitter>
                        </div>
                    </div>
                </div>
                <div *ngSwitchDefault>
                    <p class="document-content">
                        {{documentContent}}
                    </p>
                </div>
            </div>
        </div>
        <div *ngIf="!isSupportedDocumentType">
            <span translate [translateParams]="{value: documentMediaType}">{{'UNSUPPORTED-DOCUMENT-TYPE'}}</span>
        </div>
    </div>
    <kendo-dialog-actions *ngIf="!loadingDocument"
        style="position:absolute;margin-left:-16px;bottom:bottom;background-color:#f5f6fb;" class="w-100 mt-3">
        <button *ngIf="documentMediaType !== 'application/json'" kendoButton (click)="openDialog()" class="float-right">
            {{ 'CLOSE' | translate }}
        </button>
        <!--Assessment context-->
        <div *ngIf="documentMediaType === 'application/json'">
            <button kendoButton (click)="updateAssessment()" [disabled]="!form.valid || !form.dirty || submitting"
                class="float-right">
                {{ 'SAVE' | translate }}
            </button>
            <button kendoButton (click)="openDialog()" class="float-right" style="margin-right:10px;">
                {{ 'CANCEL' | translate }}
            </button>
        </div>
    </kendo-dialog-actions>
</kendo-window>

<!--Close confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="dialogVisible" (close)="cancelSave(false)"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-ADD-ASSESSMENT-CLOSE' | translate }}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="cancelSave(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="cancelSave(true)" [primary]="true">{{ 'YES' | translate
            }}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Add Assessment dialog-->
<app-member-assessment-add (cancelling)="isNewAssessment=false;" [memberId]="memberId" [taskId]="taskId"
    [assessmentId]="assessmentId" [caseId]="currentCaseId" [dialogOpened]="isNewAssessment"
    (save)="afterAssessmentFulfillmentAdded($event)">
</app-member-assessment-add>

<!-- Task form dialog -->
<app-task-add [dialogOpened]="taskDialogOpened" [memberId]="memberId" (cancelling)="taskAddCancelled()"
    (save)="afterTaskAdded()">
</app-task-add>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-DELETION' | translate }}</p>
    <span class="k-font-weight-bold">{{selectedAssessmentFulfillment.name}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<app-referral [context]="'member'" *ngIf="memberId !== undefined && memberId !== null" [memberId]="memberId"
    (afterReferralProcessing)="afterReferralProcessing($event)" #referral>
</app-referral>